export default __webpack_public_path__ + "static/media/caribbeantableportrite.8fb9f6a4.webp";